function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_9_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m323.752 262h-210c-33.137 0-60 26.863-60 60v116c0 16.569 13.431 30 30 30h36v44h198v-44h36c16.569 0 30-13.431 30-30v-116c0-33.137-26.862-60-60-60z",
    fill: "#c4e5f9",
    "data-original": "#c4e5f9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.752 438h-270c-16.569 0-30-13.431-30-30v30c0 16.569 13.431 30 30 30h270c16.569 0 30-13.431 30-30v-30c0 16.569-13.431 30-30 30z",
    fill: "#9eb6f4",
    "data-original": "#9eb6f4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.752 482h198v30h-198z",
    fill: "#9eb6f4",
    "data-original": "#9eb6f4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.752 225h-82v37c0 22.644 18.356 41 41 41s41-18.356 41-41z",
    fill: "#5f4c2e",
    "data-original": "#ffe4c2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.752 398h-30v70h30c19.33 0 35-15.67 35-35 0-19.33-15.669-35-35-35z",
    fill: "#5f4c2e",
    "data-original": "#ffe4c2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.752 438h-30v30h30c19.33 0 35-15.67 35-35 0-5.369-1.212-10.453-3.373-15-5.617 11.824-17.665 20-31.627 20z",
    fill: "#3c290e",
    "data-original": "#f2d1a5",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.928 35.045c-11.052-10.743-24.823-18.855-40.223-23.278l-10.685 2.715-6.148-5.958c-3.323-.346-6.703-.524-10.12-.524-52.469 0-95 41.34-95 92.341v13.318c0 51 42.531 92.341 95 92.341 3.416 0 6.796-.178 10.121-.524 2.932-.293 5.828-.728 8.669-1.279 18.699-3.649 35.415-12.635 48.386-25.243 17.191-16.71 27.824-39.795 27.824-65.296v-13.318c0-25.499-10.632-48.585-27.824-65.295z",
    fill: "#000000",
    "data-original": "#616161",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.752 111.03v66.556c0 36.68-29.549 66.414-66 66.414-36.451 0-66-29.735-66-66.414v-53.514c8.176 2.125 17.044 2.781 26.301 2.781 29.494 0 54.962-13.557 66.916-40.853 10.082 12.312 23.537 21.244 38.783 25.03z",
    fill: "#5f4c2e",
    "data-original": "#ffe4c2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.752 243.468v-151.468c0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30v151.468c-9.886 8.851-15.841 22.003-14.903 36.519 1.514 23.443 21.304 41.958 44.796 42.013 24.902.058 45.108-20.111 45.108-45-.001-13.325-5.797-25.293-15.001-33.532z",
    fill: "#a878e1",
    "data-original": "#f88fa4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.645 292c-19.306-.045-36.102-12.563-42.318-30.032-1.979 5.581-2.888 11.669-2.478 18.019 1.514 23.443 21.304 41.958 44.796 42.013 24.902.058 45.107-20.111 45.107-45 0-5.259-.915-10.301-2.574-14.991-6.192 17.503-22.898 30.037-42.533 29.991z",
    fill: "#9659b7",
    "data-original": "#f05475",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453.752,
    cy: 277,
    fill: "#ffffff",
    r: 16,
    "data-original": "#ffffff",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.752 285.5h15v15h-15z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.752 430.5h15v15h-15z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.252 358h15v15h-15z",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "Outline_9_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.252 391.997c0-9.771-3.471-14.976-6.26-19.159-2.252-3.378-3.74-5.61-3.74-10.838h-15c0 9.771 3.471 14.976 6.26 19.159 2.252 3.378 3.74 5.61 3.74 10.838 0 5.229-1.488 7.46-3.74 10.838-2.789 4.183-6.26 9.389-6.26 19.16s3.471 14.978 6.26 19.162c2.252 3.379 3.74 5.611 3.74 10.841s-1.488 7.462-3.74 10.841c-2.789 4.184-6.26 9.39-6.26 19.161h15c0-5.23 1.488-7.462 3.74-10.841 2.789-4.184 6.26-9.39 6.26-19.162 0-9.771-3.471-14.978-6.26-19.161-2.252-3.379-3.74-5.611-3.74-10.841 0-5.229 1.488-7.46 3.74-10.838 2.79-4.183 6.26-9.389 6.26-19.16z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.252 362h-15c0 5.228-1.488 7.46-3.74 10.838-2.789 4.183-6.26 9.389-6.26 19.159s3.471 14.977 6.26 19.16c2.252 3.378 3.74 5.61 3.74 10.838 0 5.23-1.488 7.462-3.74 10.841-2.789 4.184-6.26 9.39-6.26 19.161s3.471 14.978 6.26 19.162c2.252 3.379 3.74 5.611 3.74 10.841h15c0-9.771-3.471-14.978-6.26-19.161-2.252-3.379-3.74-5.611-3.74-10.841s1.488-7.462 3.74-10.841c2.789-4.184 6.26-9.39 6.26-19.162 0-9.771-3.471-14.977-6.26-19.16-2.252-3.378-3.74-5.61-3.74-10.838s1.488-7.46 3.74-10.838c2.79-4.183 6.26-9.388 6.26-19.159z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.252 412h-15c0 3.618-1.122 5.02-3.356 7.813-2.804 3.504-6.644 8.304-6.644 17.185 0 8.88 3.84 13.68 6.644 17.185 2.234 2.793 3.356 4.195 3.356 7.814 0 3.62-1.122 5.022-3.356 7.816-2.804 3.505-6.644 8.305-6.644 17.186s3.84 13.681 6.644 17.186c2.234 2.794 3.356 4.196 3.356 7.816h15c0-8.881-3.84-13.681-6.644-17.186-2.234-2.794-3.356-4.196-3.356-7.816s1.122-5.022 3.356-7.816c2.804-3.505 6.644-8.305 6.644-17.186s-3.84-13.68-6.644-17.185c-2.234-2.793-3.356-4.195-3.356-7.813s1.122-5.021 3.356-7.813c2.805-3.506 6.644-8.306 6.644-17.186z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.252 438c0 12.407-10.094 22.5-22.5 22.5h-7.634c6.312-7.418 10.134-17.019 10.134-27.5 0-19.449-13.137-35.877-31-40.906v-50.094h-15v48.5h-71.072v15h37.072v55h-97.928v15h131.928v36.5h15v-36.5h28.5c20.678 0 37.5-16.822 37.5-37.5v-53.286h-15zm-62.5 22.5h-22.5v-55h22.5c15.163 0 27.5 12.336 27.5 27.5s-12.336 27.5-27.5 27.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.752 254.5h-56.5v-21.445c14.136-12.514 23.46-30.384 24.81-50.429 18.846-19.256 29.19-44.57 29.19-71.626v-10.659c0-26.709-10.688-51.809-30.097-70.674-12.084-11.746-27.084-20.428-43.38-25.108l-1.95-.56-8.593 2.183-5.003-4.848-2.58-.269c-3.595-.375-7.262-.565-10.897-.565-56.519 0-102.5 44.789-102.5 99.841v10.659c0 27.056 10.344 52.37 29.19 71.626 1.35 20.045 10.674 37.915 24.81 50.429v21.445h-56.5c-37.22 0-67.5 30.28-67.5 67.5v17.714h15v-17.714c0-28.949 23.552-52.5 52.5-52.5h57.082c3.235 20.749 19.669 37.183 40.418 40.418v32.082h15v-32.082c20.749-3.235 37.183-19.669 40.418-40.418h57.082c14.774 0 28.134 6.144 37.683 16h-24.683v15h34.877c2.109 4.679 3.551 9.718 4.206 15h-23.083v15h23.5v39.214h15v-47.714c0-37.22-30.28-67.5-67.5-67.5zm-178.5-140.126v44.12c-9.103-14.008-14-30.335-14-47.494v-10.659c0-46.781 39.252-84.841 87.5-84.841 2.267 0 4.547.086 6.807.256l7.25 7.025 12.733-3.235c13.191 4.114 25.312 11.305 35.158 20.876 16.478 16.017 25.552 37.295 25.552 59.918v10.66c0 17.159-4.897 33.485-14 47.494v-53.329l-5.692-1.414c-13.437-3.336-25.466-11.118-34.788-22.502l-7.76-9.477-4.913 11.219c-10.12 23.108-32.006 36.362-60.046 36.362-9.99 0-17.748-.807-24.414-2.54zm107 147.626c0 18.472-15.028 33.5-33.5 33.5s-33.5-15.028-33.5-33.5v-18.657c10.054 5.201 21.437 8.157 33.5 8.157s23.446-2.956 33.5-8.157zm-33.5-25.5c-32.257 0-58.5-26.429-58.5-58.915v-44.397c5.563.788 11.723 1.165 18.801 1.165 30.159 0 54.605-12.799 68.639-35.509 8.612 8.146 18.631 14.19 29.561 17.816v60.925c-.001 32.486-26.244 58.915-58.501 58.915z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.542 445.5h31.21v-15h-32.5v-15h18.5v-15h-18.5v-45.786h-15v83.286c0 20.678 16.822 37.5 37.5 37.5h28.5v36.5h15v-36.5h36.072v-15h-79.572c-9.777 0-18.113-6.271-21.21-15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.252 342v63.5h111.928v-15h-96.928v-48.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.379 207.907 8.746 12.187c3.135-2.25 8.229-3.593 13.627-3.593s10.492 1.343 13.627 3.593l8.746-12.187c-5.674-4.072-13.828-6.407-22.373-6.407s-16.699 2.335-22.373 6.407z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m491.252 92c0-20.678-16.822-37.5-37.5-37.5s-37.5 16.822-37.5 37.5v13.535h15v-13.535c0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5v8.5h-18.5v15h18.5v25h-32.5v15h32.5v25h-18.5v15h18.5v51.319l2.497 2.236c7.946 7.113 12.503 17.298 12.503 27.945 0 20.678-16.822 37.5-37.5 37.5h-.09c-19.667-.046-36.064-15.419-37.329-34.995-.054-.838-.081-1.68-.081-2.504 0-10.646 4.557-20.832 12.503-27.945l2.497-2.236v-126.285h-15v119.733c-9.571 9.779-15 22.98-15 36.732 0 1.144.038 2.311.112 3.469 1.772 27.429 24.729 48.965 52.28 49.03h.107c28.948 0 52.5-23.551 52.5-52.5 0-13.752-5.428-26.953-15-36.732v-148.267z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.252 211v43.734c-9.29 3.138-16 11.93-16 22.266 0 12.958 10.542 23.5 23.5 23.5s23.5-10.542 23.5-23.5c0-10.336-6.71-19.128-16-22.266v-43.734zm16 66c0 4.687-3.813 8.5-8.5 8.5s-8.5-3.813-8.5-8.5 3.813-8.5 8.5-8.5 8.5 3.813 8.5 8.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.056 173.697-9.697-9.697 9.697-9.697-10.607-10.606-9.697 9.696-9.696-9.696-10.607 10.606 9.697 9.697-9.697 9.697 10.607 10.606 9.696-9.696 9.697 9.696z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.449 143.697-9.697 9.696-9.696-9.696-10.607 10.606 9.697 9.697-9.697 9.697 10.607 10.606 9.696-9.696 9.697 9.696 10.607-10.606-9.697-9.697 9.697-9.697z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.252 0h15v35.5h-15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.627 21.671h35.5v15h-35.5z",
    transform: "matrix(.5 -.866 .866 .5 222.924 444.46)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.628 11.421h15v35.5h-15z",
    transform: "matrix(.866 -.5 .5 .866 40.494 209.471)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.b6caf1b3a7fc03066c359d2519a94a8c.svg";
export { ForwardRef as ReactComponent };